<app-header (height)="setHeaderHeight($event)"></app-header>

<div
  id="teacher-calendar"
  [ngStyle]="{ height: 'calc(100% - ' + headerHeight + 'px' }"
>
  <ng-container *ngIf="!loading">
    <app-jitsi
      [room]="room"
      [domain]="domain"
      (onDismiss)="onDismissCall()"
      (updateTimeClass)="onUpdateTimeClass()"
      (onToggleChat)="onToggleChat($event)"
    ></app-jitsi>
  </ng-container>
  <!-- Loading -->
  <div
    class="backdrop"
    *ngIf="loading"
    [style.display]="loading ? 'block' : 'none'"
  >
    <div class="flex-center loading">
      <mat-spinner color="accent" diameter="50"></mat-spinner>
      <div class="loading-title margin-top-1">{{ message }}</div>
    </div>
  </div>
</div>

<div
  id="messages-content"
  class="custom-chat"
  *ngIf="showChat"
  [ngStyle]="{
    top: headerHeight + 'px',
    height: 'calc( 100% - ' + headerHeight + 'px)'
  }"
>
  <div id="messages-content-child">
    <app-chat-conversation [chatSelected]="chatSelected" [minimized]="true">
    </app-chat-conversation>
  </div>
</div>
